import { Component } from '@angular/core';
import { IDualMultiSelectElement } from '../../../shared/dual-multi-select/dual-multi-select.component';

@Component({
  selector: 'dual-multi-select-demo',
  template: `
    <div>
      <div><label><input type="checkbox" [(ngModel)]="disabled"> Disabled</label></div>
      <div><label><input type="checkbox" [(ngModel)]="loading"> Loading</label></div>
      <br/>
      <div>CurrentValues: {{currentValues | json}}</div>

      <dual-multi-select
        [label]="labelAdd"
        [possibleValues]="possibleValues"
        [(currentValues)]="currentValues"
        (onChange)="onChange()"
        [selectDisabled]="disabled"
        [selectLoading]="loading">
      </dual-multi-select>

      <br/>
      <div>CurrentValues: {{removeElements | json}}</div>

      <dual-multi-select
        [label]="labelRemove"
        [modeRemove]="true"
        [possibleValues]="possibleElements"
        [(currentValues)]="removeElements"
        (onChange)="onChange()"
        [selectDisabled]="disabled"
        [selectLoading]="loading">
      </dual-multi-select>
    </div>
  `
})
export class DualMultiSelectDemoComponent {
  public disabled:boolean = false;
  public loading:boolean = false;

  // add
  public labelAdd:string = 'Elements to add';
  public possibleValues:IDualMultiSelectElement[] = [
    {
      id: 1,
      name: 'First element'
    },
    {
      id: 2,
      name: 'Second element'
    }
  ];

  public currentValues:IDualMultiSelectElement[] = [
    {
      id: 3,
      name: 'Third element'
    }
  ];

  // remove
  public labelRemove:string = 'Elements to remove';
  public possibleElements:IDualMultiSelectElement[] = [
    {
      id: 1,
      name: 'First element'
    },
    {
      id: 2,
      name: 'Second element'
    }
  ];

  public removeElements:IDualMultiSelectElement[] = [
    {
      id: 3,
      name: 'Third element'
    }
  ];

  public onChange() {
    console.log('onChange callback triggered');
  }
}